import { getQrCode } from 'Api';
import { useMutation } from 'react-query';

export const useGetQrCode = () => {
	return useMutation((data: string) => getQrCode(data));
};
